var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-drawer',{attrs:{"name":"access-denied"}},[_c('div',{class:_vm.$style.container},[_c('p',{class:_vm.$style.text},[_vm._v(" "+_vm._s(_vm.$t('client.accessDenied'))+" ")]),_c('v-button',{attrs:{"color":"black-primary-light","size":"xxl"},on:{"click":_vm.onClose}},[_vm._v(" "+_vm._s(_vm.$t('continue'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }